import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { Store } from 'antd/lib/form/interface';
import React, { useContext, useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import AuthWrapper from 'components/base/AuthWrapper';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import FormWrapper from 'components/molecules/FormWrapper';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import { pristupSMSGet, pristupSMSPost } from 'services/akcionar/pristupSMS';

import routePathEnum from 'enums/routePathEnum';

interface IAkcionarSMS {}

const AkcionarSMS: React.FC<IAkcionarSMS> = () => {
    const [form] = useForm();
    const { tokenURL, token } = useContext(Context);
    const { navigateWorkaround } = useNavigateWorkaround();
    const [loading, setLoading] = useState<boolean>(false);
    const [errMessage, setErrMessage] = useState<string>('');
    const [success, setSuccess] = useState<boolean>(false);

    useEffect(() => {
        setLoading(val => !val);
        pristupSMSGet(token, tokenURL)
            .catch(() => setErrMessage('AKCIONAR_SMS_ODESLAT_ERR'))
            .finally(() => setLoading(val => !val));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onFinish = (value: Store) => {
        pristupSMSPost(value.kod)
            .then(() => setSuccess(true))
            .catch(() => setErrMessage('CHYBA_SMS'));
    };
    return (
        <AuthWrapper>
            {!success ? (
                <LoadingWrapper loading={loading}>
                    <Title text="AKCIONAR_PRIPOJENI" level={2} />
                    <Paragraph text="AKCIONAR_PRIPOJENI_TXT" />
                    <Title text="OPISTE_SMS" level={2} />
                    <FormWrapper onFinish={onFinish} outForm={form}>
                        <InputComponent label="SMS_KOD" name="kod" extramessage={errMessage} notRequired={true} />
                        <Row gutter={15}>
                            <Col>
                                <ButtonComponent
                                    onClick={() => form.submit()}
                                    buttontext="POKRACOVAT"
                                    id="akcionarSMSpokracovatBtn"
                                />
                            </Col>

                            <Col>
                                <ButtonComponent
                                    buttontext="AKCIONAR_SMS_ZNOVU"
                                    id="akcionarSMSpreposlatBtn"
                                    onClick={() => pristupSMSGet(token, tokenURL)}
                                />
                            </Col>
                        </Row>
                    </FormWrapper>
                </LoadingWrapper>
            ) : (
                <>
                    <Row>
                        <Title level={3} text="AKCIONAR_PRIPOJENI_USPECH" />
                    </Row>
                    <Row>
                        <ButtonComponent
                            buttontext="POKRACOVAT"
                            id="akcionarSMSpokracovatAltBtn"
                            onClick={() => navigateWorkaround(routePathEnum.MAIN_PAGE)}
                        />
                    </Row>
                </>
            )}
        </AuthWrapper>
    );
};

export default AkcionarSMS;
